import { Pipe, PipeTransform } from '@angular/core';

import { Urls } from '@helper/urls';
import { ProductMeta } from '@proto/store/api/common/common';

@Pipe({ name: 'colorLink', standalone: true })
export class ColorLinkPipe implements PipeTransform {
  transform(productId: string | undefined, colorId: string): string {
    if (!productId) {
      return '';
    }
    return Urls.fromMeta(
      ProductMeta.fromPartial({
        productId: productId,
      }),
      colorId
    );
  }
}

@Pipe({ name: 'sizeLink', standalone: true })
export class SizeLinkPipe implements PipeTransform {
  transform(skuId: string): string {
    return Urls.fromMeta(
      ProductMeta.fromPartial({
        productId: skuId,
      })
    );
  }
}
